{
  "labels": {
    "paste": "لصق",
    "pasteAsPlaintext": "اللصق كنص عادي",
    "pasteCharts": "لصق الرسوم البيانية",
    "selectAll": "تحديد الكل",
    "multiSelect": "إضافة عنصر للتحديد",
    "moveCanvas": "نقل لوح الرسم",
    "cut": "قص",
    "copy": "نسخ",
    "copyAsPng": "نسخ إلى الحافظة بصيغة PNG",
    "copyAsSvg": "نسخ إلى الحافظة بصيغة SVG",
    "copyText": "نسخ إلى الحافظة كنص",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "جلب للأمام",
    "sendToBack": "أرسل للخلف",
    "bringToFront": "أحضر للأمام",
    "sendBackward": "أرسل للخلف",
    "delete": "حذف",
    "copyStyles": "نسخ الأنماط",
    "pasteStyles": "لصق الأنماط",
    "stroke": "الخط",
    "background": "الخلفية",
    "fill": "التعبئة",
    "strokeWidth": "سُمك الخط",
    "strokeStyle": "نمط الخط",
    "strokeStyle_solid": "متصل",
    "strokeStyle_dashed": "متقطع",
    "strokeStyle_dotted": "منقط",
    "sloppiness": "الإمالة",
    "opacity": "الشفافية",
    "textAlign": "محاذاة النص",
    "edges": "الحواف",
    "sharp": "حادة",
    "round": "دائرية",
    "arrowheads": "رؤوس الأسهم",
    "arrowhead_none": "لا شيء",
    "arrowhead_arrow": "سهم",
    "arrowhead_bar": "شريط",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "مثلث",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "حجم الخط",
    "fontFamily": "نوع الخط",
    "addWatermark": "إضافة \"مصنوعة بواسطة Excalidraw\"",
    "handDrawn": "رسم باليد",
    "normal": "عادي",
    "code": "رمز",
    "small": "صغير",
    "medium": "متوسط",
    "large": "كبير",
    "veryLarge": "كبير جدا",
    "solid": "كامل",
    "hachure": "خطوط",
    "zigzag": "متعرج",
    "crossHatch": "خطوط متقطعة",
    "thin": "نحيف",
    "bold": "داكن",
    "left": "الـيسار",
    "center": "وسط",
    "right": "يمين",
    "extraBold": "عريض",
    "architect": "معماري",
    "artist": "رسام",
    "cartoonist": "كرتوني",
    "fileTitle": "إسم الملف",
    "colorPicker": "منتقي اللون",
    "canvasColors": "تستخدم على القماش",
    "canvasBackground": "خلفية اللوحة",
    "drawingCanvas": "لوحة الرسم",
    "layers": "الطبقات",
    "actions": "الإجراءات",
    "language": "اللغة",
    "liveCollaboration": "التعاون المباشر...",
    "duplicateSelection": "تكرار",
    "untitled": "غير معنون",
    "name": "الاسم",
    "yourName": "اسمك",
    "madeWithExcalidraw": "مصنوعة بواسطة Excalidraw",
    "group": "تحديد مجموعة",
    "ungroup": "إلغاء تحديد مجموعة",
    "collaborators": "المتعاونون",
    "showGrid": "إظهار الشبكة",
    "addToLibrary": "أضف إلى المكتبة",
    "removeFromLibrary": "حذف من المكتبة",
    "libraryLoadingMessage": "جارٍ تحميل المكتبة…",
    "libraries": "تصفح المكتبات",
    "loadingScene": "جاري تحميل المشهد…",
    "align": "محاذاة",
    "alignTop": "محاذاة إلى اﻷعلى",
    "alignBottom": "محاذاة إلى اﻷسفل",
    "alignLeft": "محاذاة إلى اليسار",
    "alignRight": "محاذاة إلى اليمين",
    "centerVertically": "توسيط عمودي",
    "centerHorizontally": "توسيط أفقي",
    "distributeHorizontally": "التوزيع الأفقي",
    "distributeVertically": "التوزيع عمودياً",
    "flipHorizontal": "قلب عامودي",
    "flipVertical": "قلب أفقي",
    "viewMode": "نمط العرض",
    "share": "مشاركة",
    "showStroke": "إظهار منتقي لون الخط",
    "showBackground": "إظهار منتقي لون الخلفية",
    "toggleTheme": "غير النمط",
    "personalLib": "المكتبة الشخصية",
    "excalidrawLib": "مكتبتنا",
    "decreaseFontSize": "تصغير حجم الخط",
    "increaseFontSize": "تكبير حجم الخط",
    "unbindText": "فك ربط النص",
    "bindText": "ربط النص بالحاوية",
    "createContainerFromText": "نص مغلف في حاوية",
    "link": {
      "edit": "تعديل الرابط",
      "editEmbed": "تحرير الرابط وإدراجه",
      "create": "إنشاء رابط",
      "createEmbed": "إنشاء رابط و إدراجه",
      "label": "رابط",
      "labelEmbed": "رابط و إدراج",
      "empty": "لم يتم تعيين رابط"
    },
    "lineEditor": {
      "edit": "تحرير السطر",
      "exit": "الخروج من المُحرر"
    },
    "elementLock": {
      "lock": "قفل",
      "unlock": "فتح",
      "lockAll": "قفل الكل",
      "unlockAll": "فتح الكل"
    },
    "statusPublished": "نُشر",
    "sidebarLock": "إبقاء الشريط الجانبي مفتوح",
    "selectAllElementsInFrame": "تحديد جميع العناصر في الإطار",
    "removeAllElementsFromFrame": "إزالة جميع العناصر من الإطار",
    "eyeDropper": "اختيار اللون من القماش",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "لا توجد عناصر أضيفت بعد...",
    "hint_emptyLibrary": "حدد عنصر على القماش لإضافته هنا، أو تثبيت مكتبة من المستودع العام أدناه.",
    "hint_emptyPrivateLibrary": "حدد عنصر على القماش لإضافته هنا."
  },
  "buttons": {
    "clearReset": "إعادة تعيين اللوحة",
    "exportJSON": "صدر الملف",
    "exportImage": "تصدير الصورة...",
    "export": "حفظ إلى...",
    "copyToClipboard": "نسخ إلى الحافظة",
    "save": "احفظ للملف الحالي",
    "saveAs": "حفظ كـ",
    "load": "فتح",
    "getShareableLink": "احصل على رابط المشاركة",
    "close": "غلق",
    "selectLanguage": "اختر اللغة",
    "scrollBackToContent": "الرجوع إلى المحتوى",
    "zoomIn": "تكبير",
    "zoomOut": "تصغير",
    "resetZoom": "إعادة تعيين الشاشة",
    "menu": "القائمة",
    "done": "تم",
    "edit": "تعديل",
    "undo": "تراجع",
    "redo": "إعادة تنفيذ",
    "resetLibrary": "إعادة ضبط المكتبة",
    "createNewRoom": "إنشاء غرفة جديدة",
    "fullScreen": "شاشة كاملة",
    "darkMode": "الوضع المظلم",
    "lightMode": "الوضع المضيء",
    "zenMode": "وضع التأمل",
    "objectsSnapMode": "التقط إلى العناصر",
    "exitZenMode": "إلغاء الوضع الليلى",
    "cancel": "إلغاء",
    "clear": "مسح",
    "remove": "إزالة",
    "embed": "تبديل الإدراج",
    "publishLibrary": "انشر",
    "submit": "أرسل",
    "confirm": "تأكيد",
    "embeddableInteractionButton": "اضغط للتفاعل"
  },
  "alerts": {
    "clearReset": "هذا سيُزيل كامل اللوحة. هل أنت متأكد؟",
    "couldNotCreateShareableLink": "تعذر إنشاء رابطة المشاركة.",
    "couldNotCreateShareableLinkTooBig": "تعذر إنشاء رابط قابل للمشاركة: المشهد كبير جدًا",
    "couldNotLoadInvalidFile": "تعذر التحميل، الملف غير صالح",
    "importBackendFailed": "فشل الاستيراد من الخادوم.",
    "cannotExportEmptyCanvas": "لا يمكن تصدير لوحة فارغة.",
    "couldNotCopyToClipboard": "تعذر النسخ إلى الحافظة.",
    "decryptFailed": "تعذر فك تشفير البيانات.",
    "uploadedSecurly": "تم تأمين التحميل بتشفير النهاية إلى النهاية، مما يعني أن خادوم Excalidraw والأطراف الثالثة لا يمكنها قراءة المحتوى.",
    "loadSceneOverridePrompt": "تحميل الرسم الخارجي سيحل محل المحتوى الموجود لديك. هل ترغب في المتابعة؟",
    "collabStopOverridePrompt": "إيقاف الجلسة سيؤدي إلى الكتابة فوق رسومك السابقة المخزنة داخليا. هل أنت متأكد؟\n\n(إذا كنت ترغب في الاحتفاظ برسمك المخزن داخليا، ببساطة أغلق علامة تبويب المتصفح بدلاً من ذلك.)",
    "errorAddingToLibrary": "تعذر إضافة العنصر للمكتبة",
    "errorRemovingFromLibrary": "تعذر إزالة العنصر من المكتبة",
    "confirmAddLibrary": "هذا سيضيف {{numShapes}} شكل إلى مكتبتك. هل أنت متأكد؟",
    "imageDoesNotContainScene": "يبدو أن هذه الصورة لا تحتوي على أي بيانات مشهد. هل قمت بتمكين تضمين المشهد أثناء التصدير؟",
    "cannotRestoreFromImage": "تعذر استعادة المشهد من ملف الصورة",
    "invalidSceneUrl": "تعذر استيراد المشهد من عنوان URL المتوفر. إما أنها مشوهة، أو لا تحتوي على بيانات Excalidraw JSON صالحة.",
    "resetLibrary": "هذا سوف يمسح مكتبتك. هل أنت متأكد؟",
    "removeItemsFromsLibrary": "حذف {{count}} عنصر (عناصر) من المكتبة؟",
    "invalidEncryptionKey": "مفتاح التشفير يجب أن يكون من 22 حرفاً. التعاون المباشر معطل.",
    "collabOfflineWarning": "لا يوجد اتصال بالانترنت.\nلن يتم حفظ التغييرات التي قمت بها!"
  },
  "errors": {
    "unsupportedFileType": "نوع الملف غير مدعوم.",
    "imageInsertError": "تعذر إدراج الصورة. حاول مرة أخرى لاحقاً...",
    "fileTooBig": "الملف كبير جداً. الحد الأقصى المسموح به للحجم هو {{maxSize}}.",
    "svgImageInsertError": "تعذر إدراج صورة SVG. يبدو أن ترميز SVG غير صحيح.",
    "failedToFetchImage": "",
    "invalidSVGString": "SVG غير صالح.",
    "cannotResolveCollabServer": "تعذر الاتصال بخادم التعاون. الرجاء إعادة تحميل الصفحة والمحاولة مرة أخرى.",
    "importLibraryError": "تعذر تحميل المكتبة",
    "collabSaveFailed": "تعذر الحفظ في قاعدة البيانات. إذا استمرت المشاكل، يفضل أن تحفظ ملفك محليا كي لا تفقد عملك.",
    "collabSaveFailed_sizeExceeded": "تعذر الحفظ في قاعدة البيانات، يبدو أن القماش كبير للغاية، يفضّل حفظ الملف محليا كي لا تفقد عملك.",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "يبدو أنك تستخدم متصفح Brave مع إعداد <bold>حظر صارم لتتبع البصمة</bold>.",
      "line2": "قد يؤدي هذا إلى كسر <bold>عناصر النص</bold> في الرسومات الخاصة بك.",
      "line3": "من المستحسن إلغاء تفعيل هذا الإعداد. يمكنك اتباع <link>هذه الخطوات</link> لفعل ذلك.",
      "line4": "إذا لم يصلح تعطيل هذا الإعداد طريقة عرض النصوص، الرجاء كتابة <issueLink>بلاغ</issueLink> على حسابنا في GitHub، أو راسلنا على <discordLink>Discord</discordLink>"
    },
    "libraryElementTypeError": {
      "embeddable": "لا يمكن إضافة العناصر القابلة للتضمين في المكتبة.",
      "iframe": "",
      "image": "سوف يتم دعم إضافة صور إلى المكتبة قريباً!"
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "تحديد",
    "image": "إدراج صورة",
    "rectangle": "مستطيل",
    "diamond": "مضلع",
    "ellipse": "دائرة",
    "arrow": "سهم",
    "line": "خط",
    "freedraw": "رسم",
    "text": "نص",
    "library": "مكتبة",
    "lock": "الحفاظ على أداة التحديد نشطة بعد الرسم",
    "penMode": "وضع القلم - امنع اللمس",
    "link": "إضافة/تحديث الرابط للشكل المحدد",
    "eraser": "ممحاة",
    "frame": "أداة الإطار",
    "magicframe": "",
    "embeddable": "تضمين ويب",
    "laser": "مؤشر ليزر",
    "hand": "يد (أداة الإزاحة)",
    "extraTools": "المزيد من أﻷدوات",
    "mermaidToExcalidraw": "",
    "magicSettings": ""
  },
  "headings": {
    "canvasActions": "إجراءات اللوحة",
    "selectedShapeActions": "إجراءات الشكل المحدد",
    "shapes": "الأشكال"
  },
  "hints": {
    "canvasPanning": "لتحريك القماش، اضغط على عجلة الفأرة أو مفتاح المسافة أثناء السحب، أو استخدم أداة اليد",
    "linearElement": "انقر لبدء نقاط متعددة، اسحب لخط واحد",
    "freeDraw": "انقر واسحب، افرج عند الانتهاء",
    "text": "نصيحة: يمكنك أيضًا إضافة نص بالنقر المزدوج في أي مكان بأداة الاختيار",
    "embeddable": "اضغط مع السحب لإنشاء موقع ويب مضمّن",
    "text_selected": "انقر نقراً مزدوجاً أو اضغط ادخال لتعديل النص",
    "text_editing": "اضغط على Esc أو (Ctrl أو Cmd) + Enter لإنهاء التعديل",
    "linearElementMulti": "انقر فوق النقطة الأخيرة أو اضغط على Esc أو Enter للإنهاء",
    "lockAngle": "يمكنك تقييد الزاوية بالضغط على SHIFT",
    "resize": "يمكنك تقييد النسب بالضغط على SHIFT أثناء تغيير الحجم،\nاضغط على ALT لتغيير الحجم من المركز",
    "resizeImage": "يمكنك تغيير الحجم بحرية بالضغط بأستمرار على SHIFT،\nاضغط بأستمرار على ALT أيضا لتغيير الحجم من المركز",
    "rotate": "يمكنك تقييد الزوايا من خلال الضغط على SHIFT أثناء الدوران",
    "lineEditor_info": "اضغط على مفتاح (Ctrl أو Cmd) و انقر بشكل مزدوج، أو اضغط على مفتاحي (Ctrl أو Cmd) و (Enter) لتعديل النقاط",
    "lineEditor_pointSelected": "اضغط على حذف لإزالة النقطة (النِّقَاط)، Ctrl/Cmd+D للتكرار، أو اسحب للانتقال",
    "lineEditor_nothingSelected": "اختر نقطة لتعديلها (اضغط على SHIFT لتحديد عدة نِقَاط),\nأو اضغط على ALT و انقر بالفأرة لإضافة نِقَاط جديدة",
    "placeImage": "انقر لوضع الصورة، أو انقر واسحب لتعيين حجمها يدوياً",
    "publishLibrary": "نشر مكتبتك",
    "bindTextToElement": "اضغط على إدخال لإضافة نص",
    "deepBoxSelect": "اضغط على Ctrl\\Cmd للاختيار العميق، ولمنع السحب",
    "eraserRevert": "اضغط على Alt لاستعادة العناصر المعلَّمة للحذف",
    "firefox_clipboard_write": "يمكن على الأرجح تمكين هذه الميزة عن طريق تعيين علم \"dom.events.asyncClipboard.clipboardItem\" إلى \"true\". لتغيير أعلام المتصفح في Firefox، قم بزيارة صفحة \"about:config\".",
    "disableSnapping": "اضغط على Ctrl أو Cmd لتعطيل الالتقاط"
  },
  "canvasError": {
    "cannotShowPreview": "تعذر عرض المعاينة",
    "canvasTooBig": "قد تكون اللوحة كبيرة جداً.",
    "canvasTooBigTip": "نصيحة: حاول تحريك العناصر البعيدة بشكل أقرب قليلاً."
  },
  "errorSplash": {
    "headingMain": "حدث خطأ. حاول <button>تحديث الصفحة</button>.",
    "clearCanvasMessage": "إذا لم تعمل إعادة التحميل، حاول مرة أخرى ",
    "clearCanvasCaveat": " هذا سيؤدي إلى فقدان العمل ",
    "trackedToSentry": "تم تتبع الخطأ في المعرف {{eventId}} على نظامنا.",
    "openIssueMessage": "حرصنا على عدم إضافة معلومات المشهد في بلاغ الخطأ. في حال كون مشهدك لا يحمل أي معلومات خاصة نرجو المتابعة على <button>نظام تتبع الأخطاء</button>. نرجو إضافة المعلومات أدناه بنسخها ولصقها في محتوى البلاغ على GitHub.",
    "sceneContent": "محتوى المشهد:"
  },
  "roomDialog": {
    "desc_intro": "يمكنك دعوة الآخرين لمشاركتك نفس الجلسة التي تعمل عليها.",
    "desc_privacy": "لا تقلق، الجلسة تستخدم التشفير من النهاية إلى النهاية، لذلك فإن أي شيء ترسمه سيبقى خاصاً. لن يتمكن حتى الخادوم الخاص بنا من رؤية ما توصلت إليه.",
    "button_startSession": "بدء الجلسة",
    "button_stopSession": "إيقاف الجلسة",
    "desc_inProgressIntro": "تجري الآن المشاركة الحية.",
    "desc_shareLink": "شارك هذا الرابط مع أي شخص تريده أن يشاركك الجلسة:",
    "desc_exitSession": "إيقاف الجلسة سيؤدي إلى قطع الاتصال الخاص بك من الغرفة، ولكن ستتمكن من مواصلة العمل مع المشهد، محليا. لاحظ أن هذا لن يؤثر على الأشخاص الآخرين، و سيظلون قادرين على التعاون في إصدارهم.",
    "shareTitle": "الانضمام إلى جلسة تعاون حية على Excalidraw"
  },
  "errorDialog": {
    "title": "خطأ"
  },
  "exportDialog": {
    "disk_title": "حفظ الملف للجهاز",
    "disk_details": "تصدير بيانات المشهد إلى ملف يمكنك الاستيراد منه لاحقاً.",
    "disk_button": "إحفظ لملف",
    "link_title": "رابط قابل للمشاركة",
    "link_details": "صدر الملف للمشاهدة فقط.",
    "link_button": "التصدير كرابط",
    "excalidrawplus_description": "حفظ المشهد إلى مساحة العمل +Excalidraw الخاصة بك.",
    "excalidrawplus_button": "تصدير",
    "excalidrawplus_exportError": "تعذر التصدير إلى +Excalidraw في الوقت الحالي..."
  },
  "helpDialog": {
    "blog": "اقرأ مدونتنا",
    "click": "انقر",
    "deepSelect": "تحديد عميق",
    "deepBoxSelect": "تحديد عميق داخل المربع، ومنع السحب",
    "curvedArrow": "سهم مائل",
    "curvedLine": "خط مائل",
    "documentation": "دليل الاستخدام",
    "doubleClick": "انقر مرتين",
    "drag": "اسحب",
    "editor": "المحرر",
    "editLineArrowPoints": "تحرير سطر/نقاط سهم",
    "editText": "تعديل النص / إضافة تسمية",
    "github": "عثرت على مشكلة؟ إرسال",
    "howto": "اتبع التعليمات",
    "or": "أو",
    "preventBinding": "منع ارتبط السهم",
    "tools": "الأدوات",
    "shortcuts": "اختصارات لوحة المفاتيح",
    "textFinish": "إنهاء التعديل (محرر النص)",
    "textNewLine": "أضف سطر جديد (محرر نص)",
    "title": "المساعدة",
    "view": "عرض",
    "zoomToFit": "تكبير للملائمة",
    "zoomToSelection": "تكبير للعنصر المحدد",
    "toggleElementLock": "إغلاق/فتح المحدد",
    "movePageUpDown": "نقل الصفحة أعلى/أسفل",
    "movePageLeftRight": "نقل الصفحة يسار/يمين"
  },
  "clearCanvasDialog": {
    "title": "مسح اللوحة"
  },
  "publishDialog": {
    "title": "نشر المكتبة",
    "itemName": "إسم العنصر",
    "authorName": "إسم المؤلف",
    "githubUsername": "اسم المستخدم في جيت هب",
    "twitterUsername": "اسم المستخدم في تويتر",
    "libraryName": "اسم المكتبة",
    "libraryDesc": "وصف المكتبة",
    "website": "الموقع",
    "placeholder": {
      "authorName": "اسمك أو اسم المستخدم",
      "libraryName": "اسم مكتبتك",
      "libraryDesc": "وصف مكتبتك لمساعدة الناس على فهم استخدامها",
      "githubHandle": "معالج GitHub (اختياري)، حتى تتمكن من تحرير المكتبة عند إرسالها للمراجعة",
      "twitterHandle": "اسم مستخدم تويتر (اختياري)، حتى نعرف من الذي سيتم الإشارة إليه عند الترويج عبر تويتر",
      "website": "رابط إلى موقعك الشخصي أو في مكان آخر (اختياري)"
    },
    "errors": {
      "required": "مطلوب",
      "website": "أدخل عنوان URL صالح"
    },
    "noteDescription": "تقديم مكتبتك لتضمينها في مستودع المكتبة العامة <link></link> لأشخاص آخرين لاستخدامها في رسومهم.",
    "noteGuidelines": "تحتاج المكتبة إلى الموافقة أولا. يرجى قراءة <link>المعايير</link> قبل تقديمها. سوف تحتاج إلى حساب GitHub للتواصل وإجراء التغييرات عند الطلب، ولكن ليس مطلوبا بشكل صارم.",
    "noteLicense": "تقديمك يعني موافقتك على نشر المكتبة المقدمة تحت <link>MIT ترخيص</link>، ما يعني أن لأي أحد الحق في استخدامها دون قيود.",
    "noteItems": "يجب أن يكون لكل عنصر مكتبة اسمه الخاص حتى يكون قابلاً للتصفية. سيتم تضمين عناصر المكتبة التالية:",
    "atleastOneLibItem": "يرجى تحديد عنصر مكتبة واحد على الأقل للبدء",
    "republishWarning": "ملاحظة: بعض العناصر المحددة معينة على أنه نشرها أو تقديمها من قبل. يجب عليك فقط إعادة إرسال العناصر عند تحديث مكتبة موجودة أو إرسالها."
  },
  "publishSuccessDialog": {
    "title": "تم إرسال المكتبة",
    "content": "شكرا لك {{authorName}}. لقد تم إرسال مكتبتك للمراجعة. يمكنك تتبع الحالة"
  },
  "confirmDialog": {
    "resetLibrary": "إعادة ضبط المكتبة",
    "removeItemsFromLib": "إزالة العناصر المحددة من المكتبة"
  },
  "imageExportDialog": {
    "header": "تصدير الصورة",
    "label": {
      "withBackground": "الخلفية",
      "onlySelected": "المحدد فقط",
      "darkMode": "الوضع الداكن",
      "embedScene": "تضمين المشهد",
      "scale": "الحجم",
      "padding": "الهوامش"
    },
    "tooltip": {
      "embedScene": "سيتم حفظ بيانات المشهد في ملف PNG/SVG المصدّر بحيث يمكن استعادة المشهد منه.\nسيزيد حجم الملف المصدر."
    },
    "title": {
      "exportToPng": "تصدير بصيغة PNG",
      "exportToSvg": "تصدير بصيغة SVG",
      "copyPngToClipboard": "نسخ الـ PNG إلى الحافظة"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "نسخ إلى الحافظة"
    }
  },
  "encrypted": {
    "tooltip": "رسوماتك مشفرة من النهاية إلى النهاية حتى أن خوادم Excalidraw لن تراها أبدا.",
    "link": "مشاركة المدونة في التشفير من النهاية إلى النهاية في Excalidraw"
  },
  "stats": {
    "angle": "الزاوية",
    "element": "عنصر",
    "elements": "العناصر",
    "height": "الارتفاع",
    "scene": "المشهد",
    "selected": "المحدد",
    "storage": "التخزين",
    "title": "إحصائيات للمهووسين",
    "total": "المجموع",
    "version": "الإصدار",
    "versionCopy": "انقر للنسخ",
    "versionNotAvailable": "الإصدار غير متوفر",
    "width": "العرض"
  },
  "toast": {
    "addedToLibrary": "تمت الاضافة الى المكتبة!",
    "copyStyles": "نسخت الانماط.",
    "copyToClipboard": "نسخ إلى الحافظة.",
    "copyToClipboardAsPng": "تم نسخ {{exportSelection}} إلى الحافظة بصيغة PNG\n({{exportColorScheme}})",
    "fileSaved": "تم حفظ الملف.",
    "fileSavedToFilename": "حفظ باسم {filename}",
    "canvas": "لوحة الرسم",
    "selection": "العنصر المحدد",
    "pasteAsSingleElement": "استخدم {{shortcut}} للصق كعنصر واحد،\nأو لصق في محرر نص موجود",
    "unableToEmbed": "تضمين هذا الرابط غير مسموح حاليًا. افتح بلاغاً على GitHub لطلب عنوان Url القائمة البيضاء",
    "unrecognizedLinkFormat": "الرابط الذي ضمنته لا يتطابق مع التنسيق المتوقع. الرجاء محاولة لصق النص 'المضمن' المُزوَد من موقع المصدر"
  },
  "colors": {
    "transparent": "شفاف",
    "black": "أسود",
    "white": "أبيض",
    "red": "أحمر",
    "pink": "وردي",
    "grape": "عنبي",
    "violet": "بنفسجي",
    "gray": "رمادي",
    "blue": "أزرق",
    "cyan": "سماوي",
    "teal": "أزرق مخضر",
    "green": "أخضر",
    "yellow": "أصفر",
    "orange": "برتقالي",
    "bronze": "برونزي"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "جميع بياناتك محفوظة محليا في المتصفح الخاص بك.",
      "center_heading_plus": "هل تريد الذهاب إلى Excalidraw+ بدلاً من ذلك؟",
      "menuHint": "التصدير والتفضيلات واللغات ..."
    },
    "defaults": {
      "menuHint": "التصدير والتفضيلات وغيرها...",
      "center_heading": "الرسم البياني التصويري. بشكل مبسط.",
      "toolbarHint": "اختر أداة و ابدأ الرسم!",
      "helpHint": "الاختصارات و المساعدة"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "الألوان المخصصة الأكثر استخداما",
    "colors": "الألوان",
    "shades": "الدرجات",
    "hexCode": "رمز Hex",
    "noShades": "لا تتوفر درجات لهذا اللون"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "تصدير كصورة",
        "button": "تصدير كصورة",
        "description": "تصدير بيانات المشهد إلى ملف يمكنك الاستيراد منه لاحقاً."
      },
      "saveToDisk": {
        "title": "حفظ الملف للجهاز",
        "button": "حفظ الملف للجهاز",
        "description": "تصدير بيانات المشهد إلى ملف يمكنك الاستيراد منه لاحقاً."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "تصدير إلى Excalidraw+",
        "description": "حفظ المشهد إلى مساحة العمل +Excalidraw الخاصة بك."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "تحميل من ملف",
        "button": "تحميل من ملف",
        "description": "سيتم التحميل من الملف <bold>استبدال المحتوى الموجود</bold>.<br></br>يمكنك النسخ الاحتياطي لرسمك أولاً باستخدام أحد الخيارات أدناه."
      },
      "shareableLink": {
        "title": "تحميل من رابط",
        "button": "استبدال محتواي",
        "description": "سيتسبب تحميل رسمة خارجية <bold>باستبدال محتواك الموجود حالياً</bold>.<br></br>بإمكانك إجراء النسخ الاحتياطي لرسمتك الحالية باستخدام أحد الخيارات أدناه."
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": ""
  }
}
